import React from "react";
import "./ddd.css";

function DDDUI({ imageUrl, onBack, children }) {
  return (
    <>
      <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL}><img src={imageUrl} alt="Header" className="logo-holder" /></a>
        <div className="back-holder">
        <button onClick={onBack} className="back-default">Back</button>
        </div>
       
      </header>
      {children}
    </>
  );
}

export default DDDUI;
